export default "__VITE_ASSET__w4pmBG37__"